import {fetchUtils} from 'react-admin';
import {resourceMap} from "./resourceMap";

const apiUrl = process.env.REACT_APP_API_URL;

const httpClient = (url, options = {}) => {
    const token = localStorage.getItem('access_token');
    options.headers = new Headers(options.headers || {});
    options.headers.set('x-access-token', token || '');
    return fetchUtils.fetchJson(url, options);
};

const resolvePath = (resource, operation, params = {}) => {
    const mapping = resourceMap[resource];

    if (!mapping) return resource; // fallback: имя без маппинга

    const path = mapping[operation];
    if (typeof path === 'function') {
        return path(params.id);
    }

    return path;
};

const dataProvider = {
    getList: async (resource, params) => {
        const {page, perPage} = params.pagination;
        const offset = (page - 1) * perPage;
        const limit = perPage;

        const sortField = params.sort.field;
        const sortOrder = params.sort.order.toLowerCase();
        const sort = `${sortField}_${sortOrder}`;

        const query = new URLSearchParams({limit, offset, sort});

        Object.entries(params.filter || {}).forEach(([key, value]) => {
            query.set(key, value);
        });

        const path = resolvePath(resource, 'list');
        const url = `${apiUrl}/${path}?${query.toString()}`;
        const {json} = await httpClient(url);

        return {
            data: json.items || json,
            total: json.count || json.total || json.length || 0,
        };
    },

    getOne: async (resource, params) => {
        const path = resolvePath(resource, 'getOne', params);
        const url = `${apiUrl}/${path}`;
        const {json} = await httpClient(url);
        return {data: json};
    },

    getMany: async (resource, params) => {
        const query = new URLSearchParams();
        params.ids.forEach(id => query.append('id', id));

        const path = resolvePath(resource, 'list');
        const url = `${apiUrl}/${path}?${query.toString()}`;
        const {json} = await httpClient(url);

        return {data: json};
    },
};

export default dataProvider;
